import { liningConstants } from "../../constants";

export function linings(state = {}, action) {
  switch (action.type) {
    // get all
    case liningConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case liningConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case liningConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case liningConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case liningConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case liningConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case liningConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case liningConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case liningConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case liningConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case liningConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case liningConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case liningConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
